import { useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";

import { CreateTodoModal } from "./_components/create-todo-modal";
import { useDateRangeStore } from "./_components/date-range-picker/use-date-range-store";
import { getAllTodosQueryOptions } from "@/config/queries/query-options";
import { convertUTCtoIST } from "@/utils";
import { DateRangePicker } from "./_components/date-range-picker/date-range-picker2";
import { DataTable } from "./_components/todos-table/data-table";
import { TODO } from "./_components/todos-table/schema";
import { getColumns } from "./_components/todos-table/columns";
import { TodoStatusViewModal } from "./_components/todos-table/comps/todo-status-view-modal";

const AdminTodosPage = () => {
  const key = Cookies.get("key") as string;
  const { dateRange } = useDateRangeStore();

  // const startdate = dateRange?.from as Date;
  const startdate = convertUTCtoIST(
    new Date(new Date(dateRange?.from as Date).setHours(0))
  );
  const enddate = convertUTCtoIST(
    new Date(new Date(dateRange?.to as Date).setHours(23))
  );

  const { data, isPending, isFetching } = useQuery(
    getAllTodosQueryOptions(key, startdate, enddate)
  );

  const todosData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.todos === undefined) {
      return [];
    }

    const result = data?.todos?.map((t) => {
      return {
        id: t?._id,
        title: t?.title,
        description: t?.description,
        recipients: t?.recipients,
        createdAt: t?.createdAt,
        files: t?.files,
        deadline: t?.deadline,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [data, isPending, isFetching]);

  const columns = useMemo<ColumnDef<TODO, unknown>[]>(() => getColumns(), []);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Todos</h3>

        <div className="flex items-center gap-2">
          <DateRangePicker />
          <CreateTodoModal />
        </div>
      </div>

      <div className="mt-5 mb-10 pb-10">
        <DataTable data={todosData} columns={columns} />
      </div>

      <TodoStatusViewModal />
    </div>
  );
};

export default AdminTodosPage;
